import { createContext, useContext, useMemo } from 'react';
import useChartSettings from './hooks/useChartSettings';

export const ChartContext = createContext();
export const useChartContext = () => useContext(ChartContext);

const ChartProvider = ({ id, children }) => {
  const {
    settings,
    sources,
    chartSelect,
    conditionUpdate,
    settingsUpdate,
    xAxisUpdate,
    yAxisUpdate,
  } = useChartSettings({ id });

  const context = useMemo(
    () => ({
      chartSelect,
      conditionUpdate,
      sources,
      settings,
      settingsUpdate,
      xAxisUpdate,
      yAxisUpdate,
    }),
    [JSON.stringify(settings), sources?.length]
  );
  return (
    <ChartContext.Provider value={context}>{children}</ChartContext.Provider>
  );
};

export default ChartProvider;
